import * as PIXI from "pixi.js";

import { TGameAssetAlias } from "@src/game/screens/GameScreen";
import { IView } from "@src/core/game/components/IView";
import { Assets } from "@src/core/assets/Assets";
import { Spine } from "@pixi/spine-pixi";

export class TorchView implements IView {
  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private _torchHandleSprite!: PIXI.Sprite;
  private _fireSkeleton!: Spine;

  public constructor() {
    this._initializeAssets();
    this._parentAssets();
  }

  private _initializeAssets(): void {
    this._torchHandleSprite = new PIXI.Sprite(
      Assets.getAsset<TGameAssetAlias>("torchHandleImg"),
    );
    this._torchHandleSprite.anchor.set(0.5);
    this._torchHandleSprite.scale.set(0.5);

    this._fireSkeleton = Spine.from({
      skeleton: "fireAtlasJson",
      atlas: "fireAtlas",
    });
    this._fireSkeleton.scale.set(0.2);
    this._fireSkeleton.position.set(0, -80);
    this._fireSkeleton.state.setAnimation(0, "idle", true);
  }

  private _parentAssets(): void {
    this._view.addChild(this._fireSkeleton);
    this._view.addChild(this._torchHandleSprite);
  }
}
